import Quill from 'components/elements/quilljs/bootstrap'

export default class Bootstrap {
  static init () {
    Quill.init()
  }
}
